export const getSingleCodeContent = (
  options: Array<{
    value: string
    content: string
  }>,
  curValue: string
) => {
  if (!curValue) {
    return null
  }

  for (let i = 0; i < options.length; i++) {
    const { value, content } = options[i]
    if (value == curValue) {
      return content
    }
  }

  return curValue + '(?)'
}

export const getMultiCodeContent = (
  options: Array<{
    value: string
    content: string
  }>,
  curValue: string
) => {
  if (!curValue) {
    return null
  }

  let content = ''

  const data = curValue.split(',')
  data.forEach((selectValue, valueIndex) => {
    const index = options.findIndex((item) => {
      if (item.value == selectValue) return true
    })

    if (index == -1) {
      content += `${selectValue}(?)`
    } else {
      content += options[index].content
    }

    if (valueIndex != data.length - 1) {
      content += ','
    }
  })

  return content
}
